export enum PagesPaths {
  Search = '/',
}
